import {
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography
} from "@mui/material"
import { useContext } from "react"
import XLSX from "xlsx"
import { ImportContractContext } from "./ImportContractFormStateProvider"
import { useTranslation } from "react-i18next"

const filePathset = (e, setFieldValue, importDataContext, resetForm) => {
  e.stopPropagation()
  e.preventDefault()
  var file = e.target.files[0]

  if (file && file.name) {
    resetForm()
    setFieldValue("excelFile", file.name)
    readFile(file, importDataContext)
  }
}

const readFile = (state, importDataContext) => {
  var f = state

  const reader = new FileReader()

  reader.onload = (evt) => {
    const bstr = evt.target.result

    const wb = XLSX.read(bstr, { type: "binary" })

    const wsname = wb.SheetNames[0]
    const ws = wb.Sheets[wsname]

    let tempData = []
    const data = tempData.concat(XLSX.utils.sheet_to_json(ws, { raw: false }))
    const dataRawHeader = tempData.concat(XLSX.utils.sheet_to_json(ws, { raw: false, header: 1 }))
    const excelData = data
    const excelHeader = []

    for (const headerAttrIndex in dataRawHeader[0]) {
      const columnHeader = dataRawHeader[0][headerAttrIndex]
      const header = {
        header: columnHeader,
        accessorKey: columnHeader,
        key: columnHeader.replace(/\s/g, ""),
        fieldName: null
      }
      excelHeader.push(header)
    }

    importDataContext.updateImportData({
      excelHeader: excelHeader,
      excelData: excelData
    })
    importDataContext.addExcelHeaders(excelHeader)
  }
  reader.readAsBinaryString(f)
}

export const UploadExcelToJson = (props) => {
  const { touched, errors, setFieldValue, values, resetForm } = props
  const { t } = useTranslation()
  const importDataContext = useContext(ImportContractContext)
  return (
    <Container>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Box bgcolor="background.dark" color="foreground.inverted" borderRadius={2} padding={10}>
            <Typography variant="h1" align="center" gutterBottom>
              {t("global.upload_file", "Upload file")}
            </Typography>
            <Typography variant="bodySmall" align="center">
              {t(
                "vehicleregistry.important_function_can_change_many_details",
                "Important: The import function can change many details for multiple vehicles in a single import. Therefore, always check that the details shown in the Import Wizard steps are correct."
              )}
            </Typography>
            <Box marginTop={5} />
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <Grid item>
                <FormControl error={touched.excelFile && errors.excelFile} variant="outlined">
                  <TextField
                    style={{ display: "none" }}
                    id="excelFile"
                    type="file"
                    label={values.excelFile}
                    onChange={(e) => filePathset(e, setFieldValue, importDataContext, resetForm)}
                    error={touched.excelFile && errors.excelFile ? true : false}
                    helperText={touched.excelFile && errors.excelFile ? errors.excelFile : null}
                    variant="outlined"
                    size="small"
                  />
                  <Typography align="center" gutterBottom>
                    {values.excelFile}
                  </Typography>

                  <label htmlFor="excelFile" align="center">
                    <Button variant="contained" color="primary" component="span">
                      {t("global.select_file", "Select file")}
                    </Button>
                  </label>
                  {touched.excelFile && errors.excelFile && (
                    <FormHelperText>{errors.excelFile}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}
